<section class="desk:centered-1170-with-padding pb-14 pt-7">
  <div class="bg-purple py-7 desk:rounded-[35px] desk:p-10">
    <div class="mb-5 px-5 desk:mb-8 desk:px-0">
      <app-title [title]="{ text: data.title, as: 'h2' }" size="h2" />
    </div>

    <div
      class="no-scrollbar flex h-72 gap-x-4 overflow-x-scroll px-5 desk:grid desk:grid-cols-3 desk:gap-x-5 desk:px-0">
      @for (article of data.articles; track $index) {
        <a [routerLink]="article.url" class="w-11/12 shrink-0 desk:w-full">
          <app-option-card [image]="article.image" [isPriority]="!isImageInPreviousBlocks && $index < 3">
            <div card-title-left class="line-clamp-2">{{ article.title }}</div>
            <div card-title-right>
              <app-svg [height]="16" [width]="25" src="assets/icons/arrow-right.svg" />
            </div>
            <div card-description class="line-clamp-2">{{ article.description }}</div>
          </app-option-card>
        </a>
      }
    </div>
  </div>
  @if (data.cta; as cta) {
    <div class="mx-auto mt-5 w-fit desk:mt-4">
      <app-button [label]="cta.label" [url]="cta.url" />
    </div>
  }
</section>
